import React, { useEffect } from 'react';
import {
  Dialog,
  DialogType,
  PrimaryButton,
  DialogFooter,
  DefaultButton,
} from '@fluentui/react';
import { dialogStyle } from '../styles/common/Dialog.style';

export interface IKnowledgeBaseDialogProps {
  toggle: boolean;
  initial: boolean;
  delCategroy: Function;
  changeInitial: Function;
}

const dialogContentProps = {
  type: DialogType.normal,
  title: '删除知识卡',
  subText: '删除操作无法撤销，你确定要删除该知识卡吗？',
  closeButtonAriaLabel: '取消'
};

const modalProps = {
  isBlocking: false,
  className: 'OpenModifyDialog'
};

const KnowledgeBaseDialog: React.FC<IKnowledgeBaseDialogProps> = ({ toggle, initial, delCategroy, changeInitial }) => {
  useEffect(() => {
    !initial && changeInitial(false);
  }, [initial]);

  return (
    <Dialog
      className={dialogStyle}
      hidden={initial}
      onDismiss={() => changeInitial(true)}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
    >
      <DialogFooter>
        <DefaultButton text="取消" onClick={() => changeInitial(true)} />
        <PrimaryButton
          text="确定"
          onClick={() => {
            changeInitial(true);
            delCategroy()

          }}
        />
      </DialogFooter>
    </Dialog>
  );
};
export default KnowledgeBaseDialog;
